import { PARCEIRO, MASTER } from "../constants/funcionarioCargo";
import {
    isMultiEmpresa
}
from '@/environment';

import { api } from "@/helpers/api";
import Vue from "vue"
import { changeStyle } from "@/helpers/style"

export default {

    state: Vue.observable({
        api_token: null,
        user_id: null,
        user: null,
        simulator_state: null,
    }),

    async initialize() {

        await this.loadInfo();

        this.state.api_token = localStorage.getItem('api_token');
        this.state.user_id = parseInt(localStorage.getItem('user_id'));

        await this.statusSimulador();
    },
    async set(api_token, user_id, user) {

        localStorage.setItem('api_token', api_token);

        localStorage.setItem('user_id', user_id);

        localStorage.setItem('user', JSON.stringify(user));

        this.state = {...this.state, user_id, user, api_token}

        await this.initialize();
    },

    getEmpresaId() {
        return this.state.user.pessoa.funcionario.empresa_id;
    },
    getEmpresa () {
        return this.state.user.pessoa.funcionario.empresa;
    },
    setAvatarUsuario(avatar) {
        const user = JSON.parse(localStorage.getItem('user'));
        user.pessoa_avatar = avatar;
        localStorage.setItem('user', JSON.stringify(user));
    },
    getUserId() {
        return JSON.parse(localStorage.getItem('user_id'));
    },
    getCargoUsuario() {

        if (! this.state.user) return;

        const {funcionario_cargo_id, empresa: {empresa_tipo_id}} = this.state.user.pessoa.funcionario;

        if (!isMultiEmpresa  && empresa_tipo_id === 2) {
            return PARCEIRO;
        } else if (empresa_tipo_id === 3) {
            return MASTER;
        }
        return funcionario_cargo_id;
    },
    getCargoUsuario2() {
        const {funcionario_cargo_id, empresa: {empresa_tipo_id}} = this.state.user.pessoa.funcionario;
        
        return funcionario_cargo_id;
    },
    remove() {
        localStorage.removeItem('api_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user');
    },

    async statusSimulador()
    {
        if (this.state.simulator_state !== null) {
            return this.state.simulator_state;
        }

        const {data: {result: {data: simulador}}} = await api.get('simulador-habilitado');

        this.state.simulator_state = simulador.status;

        return simulador.status;
    },

    async loadInfo()
    {
        const {data: {result: {data: user}}} = await api.get('authenticate/me');

        this.state.user = user;

        return user;

    },

    async changeStyle() {

        const empresa  = this.state.user.pessoa.funcionario.empresa;

        changeStyle(empresa.cor_primaria, empresa.cor_secundaria);


        document.title = `CRM - ${empresa.empresa_nome_fantasia}`
    }
}



// WEBPACK FOOTER //
// ./src/store/auth.js